export default __webpack_public_path__ + "static/media/magazine3.5296f8b4.png";